import React from 'react'
import ExperienceComponent from '../../components/experience/experienceComponent'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/footer'
import { Helmet } from 'react-helmet'
export default function Experience() {
  return (
    <>
    <Helmet>
            <title>Experience — Gopal Goyal | Founding Engineer @ HiRobin</title>
            <meta name='description'
            content='Work experience of Gopal Goyal — Founding Engineer at HiRobin, Lead Software Developer at Zeon AI Labs, Graduate Engineer at ANZ, and NLP Intern at Aryma Labs.'/>
            <meta name='keywords' content='Gopal Goyal experience, HiRobin Founding Engineer, Zeon AI Labs, ANZ, Aryma Labs, AI Engineer'/>
      </Helmet>
    <Header/>
    <ExperienceComponent/>
    <Footer/>
    </>
  )
}
